import { FC } from 'react'
import { SectionStatsProps } from '@portfolio/models'
import { SectionWrapper } from '@portfolio/components'
import { styled } from '@portfolio/styles'

const StatsWrap = styled('div', {
  display: 'grid',
  rowGap: '$32',
  columnGap: '$32',

  '@md': {
    gridTemplateColumns: '1fr 1fr',
    rowGap: '$72',
  },
})

const Stat = styled('div', {
  display: 'grid',
  gap: '$16',
  '@md': {
    gap: '$24',
  },
})

const ValueWrap = styled('div', {
  display: 'flex',
})

const Value = styled('span', {
  projectFont: 'numbers01',
})

const Symbol = styled('span', {
  projectFont: 'display02',
  lin: {
    fontSize: [30, 48],
  },
  paddingTop: '$4',
})

const Label = styled('p', {
  projectFont: 'body03',
})

export const SectionStats: FC<SectionStatsProps> = ({ stats }) => {
  if (!stats || stats.length === 0) {
    return null
  }

  return (
    <SectionWrapper type={'RICH_TEXT_MD'}>
      <StatsWrap>
        {stats.map(({ label, value, symbol }, index) => (
          <Stat key={`${index}-${label}`}>
            {value && symbol && (
              <ValueWrap>
                <Value>{value}</Value>
                {symbol !== 'none' && <Symbol>{symbol}</Symbol>}
              </ValueWrap>
            )}
            {label && <Label style={{ marginTop: 0 }}>{label}</Label>}
          </Stat>
        ))}
      </StatsWrap>
    </SectionWrapper>
  )
}
